<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="SimpanMaklumat">
            <h3 class="mb-0">Hanya Diisi Oleh Pegawai Lantikan Sebelum 2003</h3>
            <br />
            <div class="pl-lg-2">
                <validation-provider name="Amaun Telah Terima" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="5"> Amaun Dalam Buku Servis* </b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="6">
                            <b-form-input v-model="Obj.AmaunTelahTerima" :state="getValidation(validationContext)" style="width: 50%" ></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Gaji pada 31.12.2002" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg="5">Gaji pada 31.12.2002 </b-col>
                        <b-col lg="1">:</b-col>
                        <b-col lg="6">
                            <b-form-input v-model="Obj.SalGrdPertama" :state="getValidation(validationContext)" style="width: 50%" ></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Klasifikasi Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col lg="5"> Klasifikasi Perkhidmatan pada 31.12.2002 * </b-col>
                        <b-col lg="1"> :</b-col>
                        <b-col lg="6">
                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.ServClassId" :options="ServClassList" @change="runMethod()" style="width: 50%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Skim Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col lg="5"> Skim Perkhidmatan pada 31.12.2002 *</b-col>
                        <b-col lg="1"> :</b-col>
                        <b-col lg="6">
                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.SchmOfServId" :options="SchmOfServList" @change="runMethod2()" style="width: 60%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Gred Jawatan Lantikan Pertama" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg="5"> Gred Jawatan pada 31.12.2002 * </b-col>
                        <b-col lg="1">:</b-col>
                        <b-col lg="6">
                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.SalGrdID" :options="SalGrdList" style="width: 60%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Tarikh Pergerakan Gaji" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="5">
                            Tarikh Pergerakan Gaji (TPG) pada 31.12.2002
                        </b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="6">
                            <b-form-select id="Tarikh Pergerakan Gaji (TPG)" name="Tarikh Pergerakan Gaji (TPG)" value-field="value" text-field="text" v-model="Obj.TPGid" :options="tpgList" style="width: 60%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>

                            <!-- <base-input type="date" v-model="ObjLantikanSblm2003.DtTPG2002" size="sm"></base-input> -->
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg="5">Tarikh Kuatkuasa </b-col>
                        <b-col lg="1">:</b-col>
                        <b-col lg="4">
                            <b-form-input v-model="Obj.EftDate" :state="getValidation(validationContext)" readonly></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-row>
                    <b-col sm="1">&nbsp;</b-col>
                </b-row>
                <validation-provider name="Catatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="5"> Catatan* </b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="6">
                            <b-form-textarea v-model="Obj.Catatan" class="custom-input" rows="4" maxlength="1000" placeholder="Masukkan catatan (maksimum 1000 aksara)"></b-form-textarea>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit">SIMPAN</b-button>
                                    <b-button size="md" variant="danger" @click="batal()">BATAL</b-button>

                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    data() {
        return {
            Obj: {
            id_SistemSaraan: 1,
            Catatan: "Bersetuju menerima opsyen Sistem Saraan Malaysia (SSM).\nPemindahan gaji dan perubahan gred gaji ke <GRED> di bawah PP Bil. 4/2002.\nTPG: <TPG>"
            },
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            tpgList: [],
            StatusSimpan: {},
        };
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        batal() {
            this.$emit("batal");
        },
        runMethod() {
            console.log("this.Obj", this.Obj);

            let Search = {
                ServClassId: this.Obj.ServClassId,
            };

            GetselenggaraService.getSenaraiSchmOfServ(Search)
                .then((resp) => {
                    this.SchmOfServList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        runMethod2() {
            console.log("this SchmOfServId", this.SchmOfServId);
            let Search2 = {
                ServClassId: this.Obj.ServClassId,
                SchmOfServId: this.Obj.SchmOfServId,
                pilihSkim: 1,
            };
            console.log("this Search2", this.Search2);
            GetselenggaraService.getSenaraiSalGrd(Search2)
                .then((resp) => {
                    this.SalGrdList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        SimpanMaklumat() {
            (this.Obj.coid = Store.state.MaklumatPeribadi.coid),
            (this.Obj.EftDate = moment(this.Obj.EftDate, "DD-MM-YYYY").format(
                "YYYY-MM-DD"
            ));
            (this.Obj.elemenId = 17),
            (this.Obj.pilihSkim = 1),
            // (this.Obj.tahun = moment(this.Obj.EftDate, "DD-MM-YYYY").format(
            //     "YYYY"
            // )),
            console.log("log", this.Obj);

            GetsalaryService.setElemen(this.Obj).then((resp) => {
                this.StatusSimpan = resp.data;
            }).then(() => {

            //console.log("StatusSimpan fdsfs", this.StatusSimpan);

            if (this.StatusSimpan.Status == 1) {
                swal
                    .fire({
                        title: "BERJAYA DI SIMPAN!",
                        text: "KLIK OK UNTUK TERUSKAN.",
                        icon: "success",
                    })
                    .then(() => {
                        this.$emit("batal");
                    });
            } else {
                swal.fire({
                    title: this.StatusSimpan.details,
                    text: "KLIK OK UNTUK TERUSKAN.",
                    icon: "error",
                }).then(() => {
                    this.$emit("batal");
                });
            }
            });
        },
    },
    computed: {
        coid() {
            return Store.state.MaklumatPeribadi[0].coid;
        },
    },
    created() {
        //this.Obj = Store.state.MaklumatPeribadi;
        Object.assign(this.Obj, Store.state.MaklumatPeribadi);
        this.Obj.EftDate = "31-12-2002",
            GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSchmOfServ()
            .then((resp) => {
                this.SchmOfServList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSalGrd()
            .then((resp) => {
                this.SalGrdList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getTPG()
            .then((resp) => {
                this.tpgList = resp.data;
                console.log("tpgList", this.tpgList);
            })
            .catch((err) => {
                console.log(err);
            });
    },
};
</script>
